export const APP_NAME = "Brainware University";
export const PERSIST_STORE_NAME = "admin";
export const REDIRECT_URL_KEY = "redirectUrl";
export const RUNSCRIPT = "Run Script";
export const RUNSCRIPTLIST = "Run Script List";

//done by
